/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file
 */


/**
 * The routes
 *
 * @type {object} The routes
 */
export default [
  // Home
  {
    path: '/home',
    name: 'home.index',
    component: require('pages/home/index/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // List Management
  {
    path: '/lists-lookup',
    name: 'lists.lookup',
    component: require('pages/lists/lookup/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },
  {
    path: '/lists-list',
    name: 'lists.list',
    component: require('pages/lists/list/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },
  {
    path: '/lists/edit/:listid',
    name: 'lists.edit',
    component: require('pages/lists/edit/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Profile reset
  {
    path: '/profiles/reset',
    name: 'profiles.reset',
    component: require('pages/profiles/reset/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // User Password Reset Request page
  {
    path: '/user/resetpw',
    name: 'user.resetpw',
    component: require('pages/user/resetpw/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },
  // User Password Reset Request page
  {
    path: '/reset-password',
    name: 'user.resetpwblind',
    component: require('pages/user/resetpwblind/index.vue'),
    // If the user needs to be authenticated to view this page
    meta: {
      guest: true,
      auth: false,
    },
  },
  // User Password Reset landing page (after clicking URL in email)
  {
    path: '/pwreset',
    name: 'pwreset.link',
    component: require('pages/user/pwresetlink/index.vue'),
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
      guest: true,
    },
  },

  // Admin user-list
  {
    path: '/admin/user-list',
    name: 'admin.user-list',
    component: require('pages/admin/user-list/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },
  // Admin user-edit
  {
    path: '/admin/user-edit',
    name: 'admin.user-edit',
    component: require('pages/admin/user-edit/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Configuration
  {
    path: '/config',
    name: 'config.index',
    component: require('pages/config/index/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Account
  {
    path: '/account',
    name: 'account.index',
    component: require('pages/account/index/index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Login
  {
    path: '/login',
    name: 'login.index',
    component: require('pages/login/index/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },

  // Login Select
  {
    path: '/login-select',
    name: 'login.select',
    component: require('pages/login/select/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      auth: true,
    },
  },

  // Register
  {
    path: '/register',
    name: 'register.index',
    component: require('pages/register/index/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/*',
    redirect: '/home',
  },
];



// WEBPACK FOOTER //
// ./src/app/routes.js